<template>
  <div class="delivery-form-line">
    <div class="delivery-form-line-cell" @click="vGoToDeliveryFormDetails">
      <span class="link" @click="vGoToDeliveryFormDetails">{{lineData.tnbl}}</span>
    </div>
    <div class="delivery-form-line-cell">
      <span>{{$dateformat(lineData.tdate_bl)}}</span>
    </div>
    <div class="delivery-form-line-cell">
      <span>{{lineData.tlib_trsp}}</span>
    </div>
    <div class="delivery-form-line-cell">
      <span>{{lineData.tnb_colis}}</span>
    </div>
    <div class="delivery-form-line-cell">
      <span>{{lineData.tpds_brut}}</span>
    </div>
    <div class="delivery-form-line-cell">
      <span>{{lineData.tstatut}}</span>
    </div>
    <div class="delivery-form-line-cell">
      <span v-if="lineData.thttp_track !== ''"><a target="_blank" :href="lineData.thttp_track">{{$_('tracking_link')}}</a></span>
    </div>
    <div class="delivery-form-line-cell">
      <span v-if="lineData.tnofact !== 0"><router-link :to="{name: 'invoicedetails', params: {invoice_id: lineData.tnofact}}"> {{lineData.tnofact}}</router-link></span>
    </div>
    <div class="delivery-form-line-cell">
      <span class="invoice-pdf" @click="vDownloadBL()"><i class="material-icons">get_app</i></span>
    </div>
    <div class="delivery-form-line-cell">
      <span class="invoice-pdf" v-if="lineData.tnliste !== 0" @click="vDownloadPackingList()"><i class="material-icons">get_app</i></span>
    </div>
  </div>
</template>

<script>

import deliveryService from '@/modules/facture/services/deliveryService';

export default {
  props: ['dataline', 'index'],
  name:'DeliveryFormLine',
  data() {
    return {
      lineData: {
        tdate_bl: this.$props.dataline.TDATE_BL,
        tnbl: this.$props.dataline.TNBL,
        tlib_trsp: this.$props.dataline.TLIB_TRSP,
        tnb_colis: this.$props.dataline.TNB_COLIS,
        tpds_brut: this.$props.dataline.TPDS_BRUT,
        tstatut: this.$props.dataline.TSTATUT,
        thttp_track: this.$props.dataline.THTTP_TRACK,
        tnofact: this.$props.dataline.TNOFACT,
        tnliste: this.$props.dataline.TNLISTE,
      }
    }
  },
  methods: {
    vDownloadBL() {
      deliveryService.getDownloadBL(this.$props.dataline.TNBL)
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.lineData.tnbl+'.pdf');
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        console.error(err);
      });
    },
    vGoToDeliveryFormDetails() {
      this.$store.dispatch('facture/SELECT', {key: 'delivery_pnbl', value: this.$props.dataline.TNBL});
      this.$router.push({name: 'deliveryformdetails', params: {delivery_form_id: this.$props.dataline.TNBL}});
    },
    vDownloadPackingList() {
      deliveryService.getDownloadPackingList(this.$props.dataline.TNLISTE)
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'liste-colisage.pdf');
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        console.error(err);
      });
    }
  }
}
</script>

<style scoped>
.delivery-form-line {
  display: flex;
  border: solid 1px #E9E9E9;
  margin-top: 10px;
  transition: all .3s;
  align-items: center;
}
.delivery-form-line-cell {
  display: flex;
  width: calc(100% / 10);
  justify-content: center;
  padding: 25px 0px;
}
.delivery-form-line-cell span {
  color:#585858;
  font-size: var(--fz-md);
  transition: all .3s;
}
.delivery-form-line:hover {
  background-color: #F5F5F5;
  cursor: pointer;
}
.delivery-form-line:hover .delivery-form-line-cell span {
  color: #8B8B8B;
}
.invoice-pdf{
  padding: 3px;
  border-style: solid;
  border-width: 1px;
}
.invoice-pdf:hover{
  background: #DDD;
}
.delivery-form-line-cell a {
  text-decoration: underline;
}
.link {
  text-decoration: underline;
}
</style>